import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a164227"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap-top" }
const _hoisted_2 = { class: "wrapper" }
const _hoisted_3 = { class: "top-list history" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h2", null, "历史记录"),
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createTextVNode(" 该系统中历史论文检测记录"),
    /*#__PURE__*/_createElementVNode("strong", null, "（请注意：已生成的报告将在生成后7天内可供下载。超期后系统将自动清理，敬请及时保存）")
  ])
], -1))
const _hoisted_5 = { class: "block" }

import {
  ref,
  reactive,
  onMounted,
  onUnmounted,
  onActivated,
  onDeactivated,
} from "vue";
import { useRoute, useRouter } from "vue-router";
import {
  getThesises,
  deleteThesis,
  paytoCheck,
} from "@/service/history/request.js";
import { getCheckTtems } from "@/service/paperDetection/request.js";
import { getUser } from "@/service/personalCenter/request.js";
import Enumeration from "@/service/enumeration.js";
import { ElMessage, ElMessageBox } from "element-plus";
import mitt from "@/service/mitt.js";
import { setLocal, clearTimer } from "@/service/common.js";


const __default__ = {
  beforeRouteEnter(to: any, from: any, next: any) {
    if (from.path == "/test_report") {
      to.meta.isBack = true;
    } else {
      to.meta.isBack = false;
    }
    next();
  },
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'history',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const checkNum = ref(); // 用户剩余次数
const timer = ref();
const renovate = ref(false); // 自动刷新
const thesisData = ref([]);
const thesisItemConfig = ref([]); // 检测项配置
const queryInfo = reactive({
  pagenum: 1, // 当前页码
  pagesize: 10, // 每页显示条数
  total: 0, // 总条数
});

// 获取用户信息
const getUserInfo = async () => {
  const res = await getUser();
  if (res && res.code && res.code == 200) {
    checkNum.value = res.data.checkNum;
    //调用传值
    mitt.emit("checkNum", checkNum.value);
    setLocal("checkNum", checkNum.value);
  }
};

// 获取历史记录列表
const getThesisesList = async () => {
  let params = {
    currentPage: queryInfo.pagenum,
    size: queryInfo.pagesize,
    isPage: true,
  };
  const res = await getThesises(params);
  if (res && res.code && res.code == 200) {
    queryInfo.total = res.data.total;
    thesisData.value = res.data.records;
  }
};

// 格式化当前检测项参数
const getCurrentDetection = (currentDetection) => {
  const obj = thesisItemConfig.value.find(
    (item) => item.key == currentDetection
  );
  return obj?.label ? obj.label : "";
};

function handleCurrentChange(newPage) {
  queryInfo.pagenum = newPage;
  getThesisesList();
}

// 自动刷新
function switchChange() {
  if (renovate.value == true) {
    timer.value = setInterval(() => {
      setTimeout(() => {
        getThesisesList();
      }, 0);
    }, 2000);
  } else {
    clearTimer(timer.value);
  }
}

// 删除检测报告
const handDelete = (checkSn) => {
  ElMessageBox.confirm("确定删除此记录吗？", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
  })
    .then(async () => {
      const res = await deleteThesis(checkSn);
      if (res && res.code && res.code == 200) {
        ElMessage.success("删除成功");
      }
      getThesisesList();
    })
    .catch(() => {});
};

// 查看检测报告
const handViewReport = (checkSn) => {
  router.push({
    name: "test_report",
    state: { checkSn },
  });
};

// 解锁检测报告
const handDeblockReport = (checkSn) => {
  ElMessageBox.confirm(
    "本次解锁报告将消耗一次您的检测次数，此后将永久免费查看报告",
    "提示",
    {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    }
  )
    .then(async () => {
      const res = await paytoCheck(checkSn);
      if (res && res.code && res.code == 200) {
        getThesisesList();
        getUserInfo();
        ElMessage.success("解锁成功");
      } else {
        ElMessage.warning(res.msg);
      }
    })
    .catch(() => {});
};

// 获取检测项配置
const getCheckConfig = async () => {
  const res = await getCheckTtems();
  if (res && res.code && res.code == 200) {
    thesisItemConfig.value = res.data;
  }
};

onMounted(() => {
  getCheckConfig();
});

onActivated(() => {
  if (!route.meta.isBack) {
    getThesisesList();
  }
});

onDeactivated(() => {
  clearTimer(timer.value);
  renovate.value = false;
});

return (_ctx: any,_cache: any) => {
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_SemiSelect = _resolveComponent("SemiSelect")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_card, {
          class: "card",
          shadow: "never"
        }, {
          default: _withCtx(() => [
            _hoisted_4,
            _createVNode(_component_el_switch, {
              modelValue: renovate.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((renovate).value = $event)),
              "active-text": "自动刷新",
              style: {"--el-switch-on-color":"#0054fe"},
              onChange: _cache[1] || (_cache[1] = ($event: any) => (switchChange()))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_card, {
          style: {"color":"rgba(116, 121, 140, 1)"},
          shadow: "never"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table, {
              data: thesisData.value,
              style: {"width":"100%"},
              "row-style": { height: '60px' },
              "header-row-style": {
              height: '60px',
              color: '#9BA2AB',
            }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  prop: "checkSn",
                  label: "检测编号",
                  "show-overflow-tooltip": true,
                  "min-width": "100px"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "checkStatus",
                  label: "状态",
                  "min-width": "80px",
                  align: "center"
                }, {
                  default: _withCtx((scope) => [
                    (scope.row.checkStatus == 0)
                      ? (_openBlock(), _createBlock(_component_el_tag, {
                          key: 0,
                          effect: "dark",
                          class: "color1"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(getCurrentDetection(scope.row.currentDetection)) + "检测中 ", 1)
                          ]),
                          _: 2
                        }, 1024))
                      : (scope.row.checkStatus == 1)
                        ? (_openBlock(), _createBlock(_component_el_tag, {
                            key: 1,
                            effect: "dark",
                            class: "color2"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" 检测成功")
                            ]),
                            _: 1
                          }))
                        : (scope.row.checkStatus == 2)
                          ? (_openBlock(), _createBlock(_component_el_tag, {
                              key: 2,
                              effect: "dark",
                              class: "color3"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" 检测失败")
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "fileType",
                  label: "类型",
                  "min-width": "70px",
                  align: "center"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "thesisTitle",
                  label: "论文题目",
                  "show-overflow-tooltip": true,
                  "min-width": "200px"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "questionNum",
                  label: "问题数",
                  "min-width": "70px",
                  align: "center"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "checkResult",
                  label: "检测结果",
                  "min-width": "80px",
                  align: "center"
                }, {
                  default: _withCtx((scope) => [
                    (scope.row.checkResult == 0)
                      ? (_openBlock(), _createBlock(_component_el_tag, {
                          key: 0,
                          effect: "dark",
                          class: "color1"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 未知")
                          ]),
                          _: 1
                        }))
                      : (scope.row.checkResult == 1)
                        ? (_openBlock(), _createBlock(_component_el_tag, {
                            key: 1,
                            effect: "dark",
                            class: "color2"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" 合格")
                            ]),
                            _: 1
                          }))
                        : (scope.row.checkResult == 2)
                          ? (_openBlock(), _createBlock(_component_el_tag, {
                              key: 2,
                              effect: "dark",
                              class: "color3"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" 不合格")
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "checkProgress",
                  label: "进度",
                  "min-width": "120px",
                  align: "center"
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_el_progress, {
                      color: "#0054fe",
                      "text-inside": true,
                      "stroke-width": 18,
                      percentage: (scope.row.checkProgress * 100).toFixed(0)
                    }, null, 8, ["percentage"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "操作",
                  "min-width": "120px"
                }, {
                  default: _withCtx((scope) => [
                    (scope.row.checkStatus == 1)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (scope.row.deducted == 0)
                            ? (_openBlock(), _createBlock(_component_el_link, {
                                key: 0,
                                underline: false,
                                onClick: ($event: any) => (handDeblockReport(scope.row.checkSn))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("解锁报告")
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true),
                          (scope.row.deducted == 1)
                            ? (_openBlock(), _createBlock(_component_el_link, {
                                key: 1,
                                underline: false,
                                onClick: ($event: any) => (handViewReport(scope.row.checkSn))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("查看报告")
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true),
                          (scope.row.deducted == 1)
                            ? (_openBlock(), _createBlock(_component_el_link, {
                                key: 2,
                                underline: false,
                                onClick: ($event: any) => (handDelete(scope.row.checkSn))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_icon, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_SemiSelect)
                                    ]),
                                    _: 1
                                  }),
                                  _createTextVNode("删除")
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_el_pagination, {
                background: "",
                onCurrentChange: handleCurrentChange,
                "hide-on-single-page": false,
                "current-page": queryInfo.pagenum,
                layout: "prev, pager, next,",
                total: queryInfo.total,
                "default-current-page": queryInfo.pagenum,
                "next-icon": "arrow-rightIcon",
                "prev-icon": "arrow-leftIcon"
              }, null, 8, ["current-page", "total", "default-current-page"])
            ])
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})